/* eslint-disable react/require-default-props */
import React from 'react'
import {ButtonSecondary} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'

import {FooterWrapper} from './styles'

export type SummaryPageFooterProps = {
  continueRoute: string
  isLastVisibleSection: boolean
  redirect: (route: string) => void
  translationKey?: string
}

const SummaryPageFooter: React.FC<SummaryPageFooterProps> = ({
  continueRoute,
  isLastVisibleSection,
  redirect,
  translationKey,
}) => {
  const {t} = useTranslation('charon')

  // the CTA navigates to the next section, so there is nothing to offer on the last visible one
  if (isLastVisibleSection) {
    return null
  }

  return (
    <FooterWrapper>
      <ButtonSecondary
        data-target="redirect-to-next-section"
        onClick={() => (continueRoute ? redirect(continueRoute) : () => null)}
      >
        {t(translationKey || 'sub-section-menu.common.continue-cta.text')}
      </ButtonSecondary>
    </FooterWrapper>
  )
}

export default SummaryPageFooter
